import { flattenMenu } from "../utils/flattenMenu";

export const preFilterGroupPrograms = (
  program,
  getFilterByProgramType = [],
  getFilterByProgramExtraTypes = [],
  getFilterByLocation = [],
  programListFilterStrict = false
) => {
  let programTypeFilter = programListFilterStrict;
  let programExtraTypeFilter = programListFilterStrict;
  let programLocationFilter = programListFilterStrict;

  if (
    getFilterByProgramType.length === 0 &&
    getFilterByProgramExtraTypes.length === 0 &&
    getFilterByLocation.length === 0
  ) {
    return true;
  }

  if (getFilterByProgramType.length > 0) {
    const programTypes =
      program?.taxonomyGroupProgramTypes?.nodes?.flatMap(
        (type) => type?.slug
      ) ?? [];

    programTypeFilter = programTypes?.some((type) =>
      getFilterByProgramType?.includes(type)
    );
  }

  if (getFilterByProgramExtraTypes.length > 0) {
    const extraTypes = program?.taxonomyAdditionalTypes?.nodes?.flatMap(
      (extraType) => extraType?.slug
    );

    programExtraTypeFilter = extraTypes?.some((extraType) =>
      getFilterByProgramExtraTypes?.includes(extraType)
    );
  }

  if (getFilterByLocation.length > 0) {
    const locations = flattenMenu(program?.geographical?.nodes, {
      idKey: "id",
      parentKey: "parentId",
      childrenKey: "children"
    });

    const combinedLocations = locations.flatMap((loc) => {
      let newlist = [];
      newlist.push(loc);

      loc?.children.forEach((locChild) => {
        newlist.push(locChild);
        newlist.push(locChild?.children);
      });

      return [...new Set(newlist.flat().filter((el) => el))];
    });

    const locationSet = combinedLocations.flatMap((location) => location?.slug);

    programLocationFilter = locationSet?.some((location) =>
      getFilterByLocation?.includes(location)
    );
  }

  if (programListFilterStrict) {
    return [
      programTypeFilter,
      programExtraTypeFilter,
      programLocationFilter
    ].every((item) => item);
  } else {
    return [
      programTypeFilter,
      programExtraTypeFilter,
      programLocationFilter
    ].some((item) => item);
  }
};

export const preFilterStandardPrograms = (
  program,
  getFilterByProgramType = [],
  getFilterByProgramExtraTypes = [],
  getFilterByLocation = [],
  getFilterByProgramFocus = [],
  programListFilterStrict = true
) => {
  let programTypeFilter = programListFilterStrict;
  let programExtraTypeFilter = programListFilterStrict;
  let programLocationFilter = programListFilterStrict;
  let programFocusFilter = programListFilterStrict;

  if (getFilterByProgramType.length > 0) {
    const programTypes =
      program?.acfProgramsMeta?.programTypes?.flatMap((type) => type?.slug) ??
      [];

    programTypeFilter = programTypes?.some((type) =>
      getFilterByProgramType?.includes(type)
    );
  }

  if (getFilterByProgramExtraTypes.length > 0) {
    const extraTypes = program?.taxonomyAdditionalTypes?.nodes?.flatMap(
      (extraType) => extraType?.slug
    );

    programExtraTypeFilter = extraTypes?.some((extraType) =>
      getFilterByProgramExtraTypes?.includes(extraType)
    );
  }

  if (getFilterByProgramFocus.length > 0) {
    const programFocusses = program?.acfProgramsMeta?.programFocuses?.flatMap(
      (focus) => focus?.slug
    );

    programFocusFilter = programFocusses?.some((focus) =>
      getFilterByProgramFocus?.includes(focus)
    );
  }

  if (getFilterByLocation.length > 0) {
    const locations = flattenMenu(program?.geographical?.nodes, {
      idKey: "id",
      parentKey: "parentId",
      childrenKey: "children"
    });

    const combinedLocations = locations.flatMap((loc) => {
      let newlist = [];
      newlist.push(loc);

      loc?.children.forEach((locChild) => {
        newlist.push(locChild);
        newlist.push(locChild?.children);
      });

      return [...new Set(newlist.flat().filter((el) => el))];
    });

    const locationSet = combinedLocations.flatMap((location) => location?.slug);

    programLocationFilter = locationSet?.some((location) =>
      getFilterByLocation?.includes(location)
    );
  }

  if (programListFilterStrict) {
    return [
      programTypeFilter,
      programExtraTypeFilter,
      programLocationFilter,
      programFocusFilter
    ].every((item) => item);
  } else {
    return [
      programTypeFilter,
      programExtraTypeFilter,
      programLocationFilter,
      programFocusFilter
    ].some((item) => item);
  }
};

/**
 *
 * the image cgi has extra options that we can add in the future, or at least assess the performance on this as is
 *  ** fit=scale-down,width=500
 *  ** fit=cover,width=500
 *  ** fit=cover,width=1200,gravity=0.5x0.5
 *  ** fit=cover,width=1200,gravity=0.5x0.5,quality=90
 *  { uri, width, height, quality }
 *
 **/
export const getSourceImageUrlToCGI = ({
  uri,
  width,
  height,
  quality,
  format
}) => {
  // console.debug("sourceImageUrlToCGI raw uri", uri, typeof uri);
  //if source include assets.gviworld.com, ignore
  if (typeof uri !== "string") {
    const theImageUri = uri?.sourceUrl || "";

    if (theImageUri?.includes("http")) {
      return getCDNProviderToUse({
        width,
        height,
        quality,
        format,
        uri: theImageUri
      });
    }

    return theImageUri;
  } else if (!uri) {
    return "";
  } else if (uri?.length < 5) {
    return uri;
  } else if (
    uri?.includes("assets.gviworld.com") ||
    uri?.includes("cdn-cgi/image") ||
    uri?.includes(".netlify/images") ||
    uri?.includes(".svg") ||
    uri?.includes(".heif") ||
    uri?.includes(".heic")
  ) {
    // console.debug("sourceImageUrlToCGI ignore", uri);
    return uri;
  } else if (uri?.includes("http")) {
    // console.debug("sourceImageUrlToCGI reformat", uri);
    return getCDNProviderToUse({ width, height, quality, format, uri });
  } else {
    // console.debug("sourceImageUrlToCGI lost", uri);
    return uri;
  }
};

export const getCDNProviderToUse = ({
  width = "",
  height = "",
  quality = "",
  format = "",
  position = "",
  fit = "",
  uri = ""
}) => {
  const cfCDN = [
    // `${process.env.NODE_ENV === "production" ? "/cdn-cgi/image/gravity=0.5x0.5" : "https://assets.gviworld.com/cdn-cgi/image/gravity=0.5x0.5"}`,
    "https://assets.gviworld.com/cdn-cgi/image/gravity=0.5x0.5",
    `${fit ? `fit=${fit}` : ""}`,
    `${format ? `format=${format}` : "format=auto"}`,
    `${quality ? `quality=${quality}` : "quality=100"}`,
    `${width ? `width=${width}` : ""}`,
    `${height ? `height=${height}` : ""}`
  ]
    ?.filter(Boolean)
    ?.join(",")
    ?.concat("/")
    ?.concat(getCDNToUse(uri));

  const netlifyCDN = [
    `/.netlify/images?${quality ? `q=${quality}` : "q=90"}`,
    `${position ? `position=${position}` : ""}`,
    `${fit ? `fit=${fit}` : ""}`,
    `${format ? `fm=${format}` : ""}`,
    `${width ? `w=${width}` : ""}`,
    `${height ? `h=${height}` : ""}`,
    "url="
  ]
    ?.filter(Boolean)
    ?.join("&")
    ?.concat(getCDNToUse(uri));

  // return process.env.NODE_ENV === "production" ? netlifyCDN : cfCDN;
  return cfCDN;
};

export const getCDNToUse = (url) => {
  if (url.includes("people.")) {
    return url.replace("people.", "cdnp.");
  }

  return url.replace("www.", "cdn.");
};
